











import CommonBase from "@/components/CommonBase";
import {Component} from "vue-property-decorator";

@Component
export default class RecaptchaCheckPage extends  CommonBase {

  goback() {
    window.history.back();
  }

  mounted() {
    this.goback(); // Go back automatically when page has been loaded (recaptcha verified ok)
  }
}
